import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpErrorResponse } from '@angular/common/http';
import { K_QUERY_PARAM_TV, SOCIAL_APP_TV_FLAG, SOCIAL_SMART_APP_TV_FLAG, token, K_QUERY_PARAM_APPLE_TV } from 'src/app/shared/constants';
import { StorageService } from './storage.service';
import { ActivatedRoute, Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { DeepLinkService } from './deep-link.service';
import { UikitService } from './uikit.service';
import { SettingsService } from './settings.service';
import { environment } from 'src/environments/environment';
import { CategoriesService } from './categories.service';
import { HomeService } from './home.service';
import { L_CATEGORY_META_DATA } from 'src/app/shared/constants';
import { liveChannel } from 'src/app/shared/constants';
import { MatDialog } from '@angular/material/dialog';
import { SeoService } from './seo.service';

declare function videojs(player: any, options?:any): any;
@Injectable({
  providedIn: 'root'
})
export class BaseService {

  loginMode: number;
  public guestSource = new BehaviorSubject(true);
  guest = this.guestSource.asObservable();
  public loaderSource = new BehaviorSubject(false);
  public signLoaderSource = new BehaviorSubject(false);
  public paymentUpdate = new BehaviorSubject(true);
  public voucherValidation = new BehaviorSubject(false);
  public showCardData = new BehaviorSubject({ no_past_due: true, session_id: undefined });
  public signinCaptchaValidation = new BehaviorSubject(0);
  public voucherCaptchaValidation = new BehaviorSubject(0);
  public headerCategoryId = new BehaviorSubject('');
  public searchData = new BehaviorSubject('');
  public paymentProcessing = new BehaviorSubject(false);
  public disableBuuton = new BehaviorSubject(false);
  authPayErrorRoute = '/auth/stripe/payment/error';
  voucherPayErrorRoute = '/voucher/payment/error';
  setTimeoutQuality: number = 1000;
  setTimeoutAudio: number = 20;
  allPages;
  baseURL;
  isLive;
  callingProgramList: boolean;
  startState: string;
  showIosApp: boolean;
  showAndroidApp: boolean;
  initLocationHref: string;
  keyQueryParamTV = K_QUERY_PARAM_TV;
  keyQueryParamAppleTV = K_QUERY_PARAM_APPLE_TV;
  disableFormButton = false;
  deviceUrl= "https://filmboxcustomerassets.s3.eu-central-1.amazonaws.com/Where-to-Watch/";
  deviceLogoUrl = "https://filmboxcustomerassets.s3.eu-central-1.amazonaws.com/Where-to-Watch/Logo/"
  params:any;
  channelsData;
  takeValue: number;
  livePlayerId: any;
  userAgentString;
  headerCloseEvent = new BehaviorSubject<Boolean>(false);
  previousSlugValue: any;
  browserType;
  appName = 'filmbox';
  selectPlan;
  telcoSlug = '';

  constructor(private http: HttpClient, private storageService: StorageService, private router: Router,
              private deepLinkService: DeepLinkService, private route: ActivatedRoute,
              private uikitService: UikitService, private settingsService: SettingsService,
              private categoryService: CategoriesService,public dialog: MatDialog,
              private homeService: HomeService, private seoService: SeoService) {
      this.appName = environment.appName;
      this.callingProgramList = false;
      if (this.appName === 'filmbox') {
        this.deviceUrl= "https://filmboxcustomerassets.s3.eu-central-1.amazonaws.com/Where-to-Watch/";
        this.deviceLogoUrl = "https://filmboxcustomerassets.s3.eu-central-1.amazonaws.com/Where-to-Watch/Logo/"
      } else if (this.appName === 'film1') {
        this.deviceUrl= "https://filmboxcustomerassets.s3.eu-central-1.amazonaws.com/Film1-Where-to-Watch/";
        this.deviceLogoUrl = "https://filmboxcustomerassets.s3.eu-central-1.amazonaws.com/Film1-Where-to-Watch/Logo/"
      } else {
        this.deviceUrl= "https://filmboxcustomerassets.s3.eu-central-1.amazonaws.com/Where-to-Watch/";
        this.deviceLogoUrl = "https://filmboxcustomerassets.s3.eu-central-1.amazonaws.com/Where-to-Watch/Logo/"
      }

  }

  getBaseUrl(url: string) {
    this.baseURL = url;
    return url;
  }


  fetchToken(userData: any) {
    const userId: string = userData.u_id;
    const devId: string = userData.d_id;
    const guestId: string = userData.g_id;
    let params = new HttpParams()
      .set('d_type', 'web')
      .set('d_id', devId);
    if (userId) {
      params = params.append('u_id', userId);
    }
    else {
      params = params.append('g_id', guestId);
    }
    const tokenURL = this.baseURL + token;
    return this.http.get(tokenURL, { params }).subscribe((response: any) => {
      if (response.status_code === 200) {
        const respData = response.data;
        this.storageService.setLocalStore('a_t', respData.access_token);
        this.storageService.setLocalStore('r_t', respData.refresh_token);
        this.router.navigateByUrl('/home');
      }
    }, (error: HttpErrorResponse) => {
      if (error.error.error.code === 1019) {
        this.storageService.removeLocalStore('u_id');
        this.storageService.removeLocalStore('d_id');
        this.storageService.removeLocalStore('g_id');
      }
    });
  }

  redirectTo(uri: string) {
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
      this.router.navigate([uri]));
  }

  checkDevice() {
    const isMobile = {
      Android() {
        return navigator.userAgent.match(/Android/i);
      },
      BlackBerry() {
        return navigator.userAgent.match(/BlackBerry/i);
      },
      iOS() {
        return navigator.userAgent.match(/iPhone|iPad|iPod/i);
      }
    };
    if (isMobile.iOS()) {
      this.showIosApp = true;
    }
    if (isMobile.Android()) {
      this.showAndroidApp = true;
    }
    if(this.showIosApp || this.showAndroidApp){
      this.browserType = "Mobile Web";
    }else{
      this.browserType = 'Desktop Web';
    }
  }

  checkBrowser(){
    const userAgentString = navigator.userAgent;
    if(userAgentString.indexOf('Chrome') > -1) return "dash";
    if(userAgentString.indexOf('Safari') > -1 && userAgentString.indexOf('Chrome') == -1) return "hls";
    if(userAgentString.indexOf('Chrome') > -1 && userAgentString.indexOf('Safari') > -1) return "dash";
    if(userAgentString.indexOf("Edge") > -1 && userAgentString.indexOf('Edg') > -1) return "dash";
    if(userAgentString.indexOf("Opera") > -1) return "dash";
    if(userAgentString.indexOf("Firefox") > -1) return "dash";
    if(userAgentString.indexOf("MSIE") > -1) return "dash";
  }

  mobileNavigate() {
    if (this.showIosApp) {
      this.deepLinkService.deeplink('isIphone');
    } else if (this.showAndroidApp) {
      this.deepLinkService.deeplink('isAndroid');
    } else {
      const user_id = this.storageService.getLocalStore('u_id');
      if(user_id) {
        this.router.navigateByUrl('/home');
      } else {
        let utm_url = this.settingsService.getUTMurl();
        window.location.href = utm_url;
      }
    }
  }

  signinCounterErrorFn() {
    let signinCounterError = this.storageService.getLocalStore('authErrorCounter');
    if (signinCounterError) {
      signinCounterError = Number(signinCounterError) + 1;
      this.signinCaptchaValidation.next(signinCounterError);
      this.storageService.setLocalStore('authErrorCounter', signinCounterError);
    } else {
      this.signinCaptchaValidation.next(1);
      this.storageService.setLocalStore('authErrorCounter', '1');
    }
  }

  voucherCounterErrorFn() {
    let voucherCounterError = this.storageService.getLocalStore('voucherErrorCounter');
    if (voucherCounterError) {
      voucherCounterError = Number(voucherCounterError) + 1;
      this.voucherCaptchaValidation.next(voucherCounterError);
      this.storageService.setLocalStore('voucherErrorCounter', voucherCounterError);
    } else {
      this.voucherCaptchaValidation.next(1);
      this.storageService.setLocalStore('voucherErrorCounter', '1');
    }
  }

  routeFn(routeValue, key:string){
    let queryParams = this.route.snapshot.queryParams;
    const socailAppTvFlag = this.storageService.getLocalStore(SOCIAL_APP_TV_FLAG);
    const socailSmartTvFlag = this.storageService.getLocalStore(SOCIAL_SMART_APP_TV_FLAG);
    if(queryParams.app === key || socailAppTvFlag === '1'){
      if(socailAppTvFlag === '1'){
        queryParams = { 'app' : this.keyQueryParamTV };
      }
      this.router.navigate([routeValue], {queryParams: queryParams})
    } else if(queryParams.app === this.keyQueryParamAppleTV || socailSmartTvFlag === '1') {
      queryParams = { 'app' : this.keyQueryParamAppleTV };
      this.router.navigate([routeValue], {queryParams: queryParams})
    } else if(queryParams.step === '3' || queryParams.step === '4') {
      this.router.navigate([], {queryParams:routeValue})
    } else {
      this.router.navigateByUrl(routeValue);
    }
  }

  getScrollHeightValue() {
    const doc = document.documentElement;
    const scrollHeightValue = (window.pageYOffset || doc.scrollTop)  - (doc.clientTop || 0);
    return scrollHeightValue;
  }

  isNumberInput(evt) {
    const charCode = (evt.which) ? evt.which : evt.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) return false;
    else return true;
  }

  onKeyDown(evt) { ["e", "E"].includes(evt.key) && evt.preventDefault() }

  /*Disable form to avoid multiple toast message*/
  disableFormBtnFn() {
    this.disableFormButton = true;
    setTimeout(()=>{
      this.disableFormButton = false;
    },this.uikitService.timeout)
  }

  goBack() {
    history.back();
  }


  navErrPage(errorResult, errRoute) {
    switch (true) {
      case (errorResult.already_subscribed):
        this.router.navigate([`${errRoute}`, 'susbcribed']);
        break;
      case (errorResult.expired):
        this.router.navigate([`${errRoute}`, 'expired']);
        break;
      case (errorResult.invalid):
        this.router.navigate([`${errRoute}`, 'invalid']);
        break;
      case (errorResult.failed):
          this.router.navigate([`${errRoute}`, 'failed']);
          break;
      default:
        this.router.navigate([`${errRoute}`, 'invalid']);
        break;
    }
  }
  isMobileOrNot() {
    return window.innerWidth <= 768;
  }

  redirect(value, val?) {
    if (value !== 'live-channel') this.closeLiveChannelPLayer();
    const slugValue = typeof(value) == 'string' ? value : value.slug;
    this.setPreviousSlugValue(slugValue);
    this.categoryService.getCategoryContents(slugValue).subscribe((data) => {
      if(data) {
        const uId = this.storageService.getLocalStore('u_id');
        data = data.filter(item => (item.component !== 'banner_widget'
        && item.component !== "continue_watching_widget" && item.component !== "my_list_widget"));
        if(!data.length) this.redirectCategory(slugValue);
        if (!uId) {
          this.setPreviousSlugValue(slugValue);
          this.redirectCollection(data, value, val);
        }
        else {
          const paramData = {category:slugValue};
          this.homeService.userContent(paramData).subscribe((personaData)=> {
            if (personaData) {
              const wishlist = personaData.find((data) => data.key === 'wishlist');
              const continueWatch = personaData.find((data) => data.key === 'continue');
              const wishlistLength = wishlist.list.length;
              const continueWatchLength = continueWatch.list.length;
              const categoryLength = data.length + wishlistLength?1:0 + continueWatchLength?1:0;
              if(categoryLength === 1 && continueWatch.length && data.key ) {
                this.router.navigate([`/list/${data.key}`]);
              } else if(categoryLength === 1 && wishlist.length && data.key) {
                this.router.navigate([`/${data.key}`]);
              } else {
                if(continueWatchLength) data.push({component:"continue_watching_widget",slug:'continue', ...continueWatch});
                if(wishlistLength) data.push({component:"my_list_widget",slug:'wishlist', ...wishlist});
                this.redirectCollection(data, value, val);
              }
            }
          })
        }
      }
    });
  }

  setPreviousSlugValue(slugValue) {
    this.previousSlugValue = ((this.router.url).split('/')[1]).split('?')[0];
    if (this.previousSlugValue === 'live') this.previousSlugValue = 'live-channel';
    if (this.previousSlugValue === slugValue) this.loaderSource.next(false);
    else this.loaderSource.next(true);
    this.previousSlugValue = slugValue;
  }

  redirectCollection(data, value, val?) {
    const otherNavigationExtras = {
      queryParams: {
        menu_item: value
      }
    };
    const collectionLength = data.length;
    const singleCollection = data[0];
    if((this.settingsService.epgEnabled === 1 || this.settingsService.smartChannelsEnabled === 1)   && singleCollection.component === "livechannel_widget") {
      this.epgWiseLivechannelsListing(otherNavigationExtras);
      return;
    }
    if(collectionLength === 1) {
      if(singleCollection.component === "livechannel_widget") this.router.navigate(['/live/channels'], otherNavigationExtras);
      else if (singleCollection.component === 'group_collection_widget') this.router.navigate(['/movies/', singleCollection.slug], otherNavigationExtras);
      else this.router.navigate(['/collection/',singleCollection.slug], otherNavigationExtras);
    } else this.redirectCategory(value, val);
  }

  redirectCategory(value, val?) {
    if(typeof(value) == 'string'){
      const otherNavigationExtras = {
        queryParams: {
          menu_item: value
        }
      };
      this.router.navigate(['/', value], otherNavigationExtras);
    } else {
      const otherNavigationExtras = {
        queryParams: {
          menu_item: value.slug
        }
      };
      this.storageService.setLocalStore(L_CATEGORY_META_DATA, value);
      this.router.navigate(['/', value.slug], otherNavigationExtras);
    }
  }

  epgWiseLivechannelsListing(otherNavigationExtras) {
    const params: HttpParams = new HttpParams()
    .set('d_type', "web")
    .set('skip', "0")
    .set('take', "12");
    const chaneelURL = environment.apiUrl + environment.version + liveChannel;
    this.http.get(chaneelURL, { params }).subscribe((response: any) => {
        if (response.status_code === 200) {
          if(response.data?.livechannels.length > 0) {
            let live_channel_slug = '';
            if(this.storageService.getLocalStore('epg_live_channel')) live_channel_slug = this.storageService.getLocalStore('epg_live_channel');
            else live_channel_slug = response.data?.livechannels[0]?.slug;
            this.router.navigate(['/live/', live_channel_slug], otherNavigationExtras);
          }
        }
      }, (error: HttpErrorResponse) => {
        this.loaderSource.next(false);
      });
  }

  closeLiveChannelPLayer() {
    const oldPlayer = document.getElementById(this.livePlayerId);
    if (oldPlayer) {
      if (document['pictureInPictureElement']) {
        document['exitPictureInPicture']();
      }
      videojs(oldPlayer).dispose();
      videojs(oldPlayer).hotkeys({
        alwaysCaptureHotkeys: false
      });
    }
    this.settingsService.showHeader = true;
    this.settingsService.showFooter = true;
    this.seoService.defaultMetaTag();
  }

  storeEPGValue(slug) {
    const uId = this.storageService.getLocalStore('u_id');
    // FIXME: Why did we do this?
    // if(uId && this.settingsService.epgEnabled) this.storageService.setLocalStore('epg_live_channel', slug);
    this.storageService.setLocalStore('epg_live_channel', slug);
  }

}
